import { PostAPI } from 'Components/Helper/Helpers';

export const SelectReport = async (request) => {
    return PostAPI(request, 'IDFCAccountStatement/GetAccountStatement');
};
